export enum BulkAddUIMessages {
  MachineProductId = 'Please add a Machine Product Id',
  InvalidLaborWarranty = 'Please enter a valid Labor Warranty days',
  InvalidPartWarranty = 'Please enter a valid Part Warranty days',
  MachineProductIdInvalid = 'Please enter product ID as number',
  InvalidLaborOrPartWarranty = "No labor or part warranty data supplied"
}
